import * as Blockly from 'blockly';
import { FieldPlusMinusBase } from '@shared/blockly/fields';

const BUTTON_SIZE = 20;
const BUTTON_PADDING = 2;

/**
 * Custom field that renders a clickable + or - button on a Blockly block.
 */
export class FieldPlusMinus extends FieldPlusMinusBase {
  private foreignObject_: SVGForeignObjectElement | null = null;
  private buttonElement_: HTMLElement | null = null;

  constructor(isPlus: boolean | string) {
    super(isPlus);
    (this as any).CURSOR = 'pointer';
  }

  override initView(): void {
    this.createBorderRect_();
    this.createButton_();
    this.updateSize_();
  }

  private createButton_(): void {
    if (!this.fieldGroup_) return;

    const fo = document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject');
    fo.setAttribute('width', `${BUTTON_SIZE + BUTTON_PADDING * 2}`);
    fo.setAttribute('height', `${BUTTON_SIZE + BUTTON_PADDING * 2}`);
    fo.setAttribute('y', '0');

    const wrapper = document.createElement('div');
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    wrapper.style.justifyContent = 'center';
    wrapper.style.width = '100%';
    wrapper.style.height = '100%';
    wrapper.style.cursor = 'pointer';
    wrapper.style.userSelect = 'none';

    const btn = document.createElement('div');
    btn.style.width = `${BUTTON_SIZE - 4}px`;
    btn.style.height = `${BUTTON_SIZE - 4}px`;
    btn.style.borderRadius = '50%';
    btn.style.backgroundColor = 'rgba(255,255,255,0.25)';
    btn.style.display = 'flex';
    btn.style.alignItems = 'center';
    btn.style.justifyContent = 'center';
    btn.style.fontSize = '14px';
    btn.style.fontWeight = 'bold';
    btn.style.color = 'rgba(255,255,255,0.9)';
    btn.style.lineHeight = '1';
    btn.textContent = this.isPlus ? '+' : '−';
    btn.title = this.isPlus ? 'Eingang hinzufügen' : 'Eingang entfernen';

    wrapper.appendChild(btn);
    fo.appendChild(wrapper);
    this.fieldGroup_.appendChild(fo);

    this.foreignObject_ = fo;
    this.buttonElement_ = btn;
  }

  protected override updateSize_(): void {
    const totalWidth = BUTTON_SIZE + BUTTON_PADDING * 2;
    const totalHeight = BUTTON_SIZE + BUTTON_PADDING * 2;

    this.size_ = new Blockly.utils.Size(totalWidth, totalHeight);

    if (this.borderRect_) {
      this.borderRect_.setAttribute('width', `${totalWidth}`);
      this.borderRect_.setAttribute('height', `${totalHeight}`);
      this.borderRect_.style.fill = 'transparent';
      this.borderRect_.style.stroke = 'none';
    }
  }
}
